export const FETCH_ACTIVITIES_SUCCESS = "ACTIVITIES/FETCH_SUCCESS";
export const FETCH_ACTIVITIES_REQUEST = "ACTIVITIES/FETCH_REQUEST";
export const FETCH_ACTIVITIES_FAILED = "ACTIVITIES/FETCH_FAILED";
export const GET_AVAILABILITY_SUCCESS = "AVAILABILITY/GET_SUCCESS";
export const GET_DAY_AVAILABILITY_SUCCESS = "DAY_AVAILABILITY/GET_SUCCESS";
export const GET_TABLE_AVAILABILITY_SUCCESS = "TABLE_AVAILABILITY/GET_SUCCESS";
export const CHECKOUT_SUCCESS = "CHECKOUT/GET_SUCCESS";

export const AVAILABILITY_UPDATE = "AVAILABILITY_UPDATE";
export const GAMES_UPDATE = "GAMES_UPDATE";
export const UPDATE_PARAMS = "UPDATE_PARAMS";

const types = {
    FETCH_ACTIVITIES_FAILED,
    FETCH_ACTIVITIES_REQUEST,
    FETCH_ACTIVITIES_SUCCESS,

    FETCH_QR_FAILED: "LIVE/FETCH_QR_FAILED",
    FETCH_QR_REQUEST: "LIVE/FETCH_QR_REQUEST",
    FETCH_QR_SUCCESS: "LIVE/FETCH_QR_SUCCESS",

    FETCH_LIVE_FAILED: "LIVE/FETCH_FAILED",
    FETCH_LIVE_REQUEST: "LIVE/FETCH_REQUEST",
    FETCH_LIVE_SUCCESS: "LIVE/FETCH_SUCCESS",

    CALCULATE_FAILED: "CALCULATE/GET_FAILED",
    CALCULATE_REQUEST: "CALCULATE/GET_REQUEST",
    CALCULATE_SUCCESS: "CALCULATE/GET_SUCCESS",

    CHECKOUT_FAILED: "CHECKOUT/GET_FAILED",
    CHECKOUT_REQUEST: "CHECKOUT/GET_REQUEST",
    CHECKOUT_SUCCESS,

    CONTACT_FAILED: "CONTACT/GET_FAILED",
    CONTACT_REQUEST: "CONTACT/GET_REQUEST",
    CONTACT_SUCCESS: "CONTACT/GET_SUCCESS",

    GET_AVAILABILITY_FAILED: "AVAILABILITY/GET_FAILED",
    GET_AVAILABILITY_REQUEST: "AVAILABILITY/GET_REQUEST",
    GET_AVAILABILITY_SUCCESS,

    GET_DAY_AVAILABILITY_FAILED: "DAY_AVAILABILITY/GET_FAILED",
    GET_DAY_AVAILABILITY_REQUEST: "DAY_AVAILABILITY/GET_REQUEST",
    GET_DAY_AVAILABILITY_SUCCESS,

    GET_TABLE_AVAILABILITY_FAILED: "TABLE_AVAILABILITY/GET_FAILED",
    GET_TABLE_AVAILABILITY_REQUEST: "TABLE_AVAILABILITY/GET_REQUEST",
    GET_TABLE_AVAILABILITY_SUCCESS,

    GET_GAME_AVAILABILITY_FAILED: "GAME_AVAILABILITY/GET_FAILED",
    GET_GAME_AVAILABILITY_REQUEST: "GAME_AVAILABILITY/GET_REQUEST",
    GET_GAME_AVAILABILITY_SUCCESS: "GAME_AVAILABILITY/GET_SUCCESS",

    AVAILABILITY_UPDATE,
    GAMES_UPDATE,
    UPDATE_PARAMS,
};

export default types;
